var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loading)?[_vm._v("\n    Validating..\n  ")]:[_vm._v("\n    You have been un-subscribed. Thank you.\n  ")]],2)}
var staticRenderFns = []

export { render, staticRenderFns }